/* ============================================================
   MONTE SEU COMBO v3 — Pops Foods
   Sem limite de unidades: o desconto é desbloqueado pela
   quantidade TOTAL escolhida. A régua é DINÂMICA por tamanho,
   derivada da tabela de tiers (window.popsComboData), que
   espelha os descontos progressivos reais (Shopify + Yampi).
   Sem tabela, cai na régua legada 1/5/10/15 → 0/5/10/15%.
   ============================================================ */

(function () {
  'use strict';

  var LEGACY_MINS = [1, 5, 10, 15];
  var LEGACY_PCTS = { 1: 0, 5: 5, 10: 10, 15: 15 };

  window.initComboBlock = function (wrapper) {
    var data = window.popsComboData || {};
    var sizes = Object.keys(data).filter(function (s) { return (data[s] || []).length; });
    if (!sizes.length) return;

    var variantIds = {};
    var qtys = {};
    sizes.forEach(function (size) {
      (data[size] || []).forEach(function (f) {
        variantIds[f.key] = f.variantId;
        qtys[f.key] = 0;
      });
    });

    var currentSize = wrapper.dataset.currentSize || sizes[0];
    if (sizes.indexOf(currentSize) === -1) currentSize = sizes[0];

    var addBtn    = wrapper.querySelector('.pops-msc-btn');
    var successEl = wrapper.querySelector('.pops-msc-success');
    var errorEl   = wrapper.querySelector('.pops-msc-error');

    function fmtMoney(cents) {
      var moneyFmt = window.popsComboMoneyFmt || 'R$ {{amount_with_comma_separator}}';
      var a = (cents / 100).toFixed(2);
      var n = String(Math.round(cents / 100));
      return moneyFmt
        .replace('{{amount_no_decimals_with_comma_separator}}', n.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace('{{amount_with_comma_separator}}', a.replace('.', ','))
        .replace('{{amount_no_decimals}}', n)
        .replace('{{amount}}', a);
    }

    // ── Helpers ───────────────────────────────────────────────
    function flavorsOf(size)  { return data[size] || []; }
    function flavorsBox(size) { return wrapper.querySelector('.pops-msc-flavors[data-size="' + size + '"]'); }
    function flavorRows()     { var b = flavorsBox(currentSize); return b ? b.querySelectorAll('.pops-msc-flavor-row') : []; }
    function sizeLabel(size)  { var b = wrapper.querySelector('.pops-msc-size-btn[data-size="' + size + '"]'); return b ? b.textContent.trim() : size; }

    function getTotal() {
      return flavorsOf(currentSize).reduce(function (sum, f) { return sum + qtys[f.key]; }, 0);
    }


    // mínimos da régua do tamanho atual, derivados da tabela de tiers
    function minsOf(size) {
      var set = {};
      flavorsOf(size).forEach(function (f) {
        Object.keys(f.tiers || {}).forEach(function (k) {
          if (f.tiers[k] > 0) set[parseInt(k)] = 1;
        });
      });
      var list = Object.keys(set).map(Number).sort(function (a, b) { return a - b; });
      if (!list.length) list = LEGACY_MINS.slice();
      if (list[0] !== 1) list.unshift(1);
      return list;
    }

    // índice do tier atual pela quantidade total
    function tierIdx(total, mins) {
      var idx = 0;
      mins.forEach(function (min, i) { if (total >= min) idx = i; });
      return idx;
    }

    // preço unitário do sabor no mínimo: tabela exata > % legado sobre o preço real
    function unitAt(f, min) {
      if (f.tiers && f.tiers[String(min)] > 0) return f.tiers[String(min)];
      var p = f.price || 0;
      return Math.round(p * (100 - (LEGACY_PCTS[min] || 0)) / 100);
    }

    // Promo "solo" do sabor (snippet pops-solo-promo), pela quantidade do PRÓPRIO sabor:
    //   fixo      → a partir de soloA unidades, cada uma sai por soloB
    //   levepague → a cada soloA unidades, paga só soloB (cumulativo)
    // Vale o menor entre promo e faixa do combo, como a Shopify faz quando os
    // descontos não são combináveis.
    function promoLinha(f, q, tierMin) {
      var faixa = unitAt(f, tierMin) * q;
      var promo = null, gratis = 0;
      if (f.soloTipo === 'fixo' && f.soloA > 0 && f.soloB > 0 && q >= f.soloA) {
        promo = f.soloB * q;
      } else if (f.soloTipo === 'levepague' && f.soloB > 0 && f.soloA > f.soloB && q >= f.soloA) {
        // grupos completos pagam soloB de cada soloA a preço cheio; as unidades
        // que sobram fora dos grupos ainda pegam a faixa do combo (como na Shopify)
        var grupos = Math.floor(q / f.soloA);
        gratis = grupos * (f.soloA - f.soloB);
        promo = grupos * f.soloB * basePriceOf(f) + (q - grupos * f.soloA) * unitAt(f, tierMin);
      }
      if (promo !== null && promo < faixa) return { total: promo, ativa: true, gratis: gratis };
      return { total: faixa, ativa: false, gratis: 0 };
    }

    function pctAt(f, min) {
      var base = basePriceOf(f);
      var unit = unitAt(f, min);
      if (base <= 0 || unit >= base) return 0;
      return 100 - Math.round(unit * 100 / base);
    }

    // frete grátis garantido ao atingir o mínimo, mesmo só com o sabor mais barato
    function freteNoMin(min) {
      var fs = flavorsOf(currentSize);
      if (!fs.length) return false;
      var minUnit = Math.min.apply(null, fs.map(function (f) { return unitAt(f, min); }));
      return minUnit * min >= 16990;
    }

    // constrói a régua do tamanho atual
    function buildLadder() {
      var ladder = wrapper.querySelector('[data-msc-ladder]');
      var fs = flavorsOf(currentSize);
      if (!ladder || !fs.length) return;
      var mins = minsOf(currentSize);
      var f0 = fs.reduce(function (a, b) { return basePriceOf(b) < basePriceOf(a) ? b : a; });
      ladder.style.gridTemplateColumns = 'repeat(' + mins.length + ', 1fr)';
      ladder.innerHTML = mins.map(function (min, i) {
        var unit = unitAt(f0, min);
        var pct = pctAt(f0, min);
        var frete = (i === mins.length - 1 && mins.length > 1) ? '<span class="pops-msc-rung-frete pops-msc-rung-top">🔥 MAIS PEDIDO</span>' : (freteNoMin(min) ? '<span class="pops-msc-rung-frete">🚚 DESCONTO FRETE</span>' : '');
        return '<div class="pops-msc-rung" data-min="' + min + '">' + frete +
          '<b>' + min + '+</b><small>unidade' + (min > 1 ? 's' : '') + '</small>' +
          '<span class="pops-msc-rung-pct">' + (pct > 0 ? pct + '% OFF' : 'preço cheio') + '</span>' +
          '<span class="pops-msc-rung-price">' + fmtMoney(unit) + '/un</span>' +
          '</div>';
      }).join('');
    }
    function basePriceOf(f) {
      if (f.tiers && f.tiers['1'] > 0) return f.tiers['1'];
      return f.price || 0;
    }

    // ── Troca de tamanho ──────────────────────────────────────
    function resetQtys() {
      sizes.forEach(function (size) {
        flavorsOf(size).forEach(function (f) { qtys[f.key] = 0; });
      });
    }

    function switchSize(newSize) {
      if (sizes.indexOf(newSize) === -1 || newSize === currentSize) return;
      currentSize = newSize;
      wrapper.dataset.currentSize = newSize;
      sizes.forEach(function (size) {
        var fBox = flavorsBox(size);
        if (fBox) fBox.hidden = (size !== newSize);
      });
      wrapper.querySelectorAll('.pops-msc-size-btn').forEach(function (btn) {
        var on = btn.dataset.size === newSize;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      resetQtys();
      buildLadder();
      render();
    }

    wrapper.querySelectorAll('.pops-msc-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { switchSize(btn.dataset.size); });
    });

    // ── Botões + e − (sem máximo) ─────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pops-msc-qty-btn');
      if (!btn || !wrapper.contains(btn)) return;
      var row = btn.closest('.pops-msc-flavor-row');
      if (!row) return;
      var flavor = row.dataset.flavor;
      if (btn.dataset.action === 'dec' && qtys[flavor] > 0) { qtys[flavor]--; render(); }
      else if (btn.dataset.action === 'inc') { qtys[flavor]++; render(); }
    });

    // ── Input editável ────────────────────────────────────────
    wrapper.querySelectorAll('.pops-msc-flavor-row').forEach(function (row) {
      var flavor = row.dataset.flavor;
      var input  = row.querySelector('.pops-msc-qty-input');
      if (!input) return;
      input.addEventListener('focus', function () { this.select(); });
      input.addEventListener('input', function () { this.value = this.value.replace(/[^0-9]/g, ''); });
      function applyValue() {
        var val = parseInt(input.value) || 0;
        if (val < 0) val = 0;
        if (val > 999) val = 999;
        qtys[flavor] = val;
        render();
      }
      input.addEventListener('blur', applyValue);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyValue(); input.blur(); }
      });
    });

    // ── Adicionar ao carrinho ─────────────────────────────────
    addBtn.addEventListener('click', function () {
      if (getTotal() === 0) return;
      if (addBtn.classList.contains('loading')) return;

      addBtn.classList.remove('ready');
      addBtn.classList.add('loading');
      addBtn.textContent = 'Adicionando...';
      successEl.classList.remove('visible');
      errorEl.classList.remove('visible');
      errorEl.textContent = '';

      var label = sizeLabel(currentSize);
      var totalSel = getTotal();
      var items = flavorsOf(currentSize)
        .filter(function (f) { return qtys[f.key] > 0 && variantIds[f.key]; })
        .map(function (f) {
          return {
            id: parseInt(variantIds[f.key]),
            quantity: qtys[f.key],
            properties: {
              '_combo': totalSel + ' unidades',
              '_tamanho': label,
              '_msc_id': 'monte-seu-combo',
              '_msc_source': window.location.pathname
            }
          };
        });

      if (!items.length) {
        errorEl.textContent = 'Nenhum item selecionado.';
        errorEl.classList.add('visible');
        addBtn.classList.remove('loading');
        render();
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Erro ao adicionar.'); });
        return res.json();
      })
      .then(function () {
        return fetch('/?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' }).then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents({ sections: sections });
        }
        var resumo = flavorsOf(currentSize)
          .filter(function (f) { return qtys[f.key] > 0; })
          .map(function (f) { return qtys[f.key] + 'x ' + f.label; })
          .join(', ');
        successEl.querySelector('.pops-msc-success-text').textContent = resumo + ' adicionado ao carrinho!';
        successEl.classList.add('visible');
        setTimeout(function () {
          resetQtys();
          render();
          successEl.classList.remove('visible');
        }, 3000);
      })
      .catch(function (err) {
        console.error(err);
        errorEl.textContent = 'Erro: ' + err.message;
        errorEl.classList.add('visible');
      })
      .finally(function () {
        addBtn.classList.remove('loading');
        render();
      });
    });

    // ── Render ────────────────────────────────────────────────
    function render() {
      var total = getTotal();
      var mins = minsOf(currentSize);
      var ti = tierIdx(total, mins);
      var _fs = flavorsOf(currentSize);
      var f0 = _fs.length ? _fs.reduce(function (a, b) { return basePriceOf(b) < basePriceOf(a) ? b : a; }) : null;

      // régua
      wrapper.querySelectorAll('.pops-msc-rung').forEach(function (rung, i) {
        rung.classList.toggle('hit', total >= parseInt(rung.dataset.min));
        rung.classList.toggle('now', i === ti && total > 0);
      });

      // barra de progresso até o próximo tier
      var ptxt = wrapper.querySelector('[data-msc-progress-txt]');
      var pfill = wrapper.querySelector('[data-msc-progress-fill]');
      if (ptxt && pfill) {
        if (total === 0) {
          ptxt.innerHTML = 'Adicione unidades e <em>desbloqueie descontos</em>';
          pfill.style.width = '0%';
        } else if (ti < mins.length - 1) {
          var next = mins[ti + 1];
          var falta = next - total;
          var ganho = f0 ? pctAt(f0, next) + '% OFF' : '';
          ptxt.innerHTML = 'Faltam <em>' + falta + ' unidade' + (falta > 1 ? 's' : '') + '</em> para <em>' + ganho + (freteNoMin(next) && !freteNoMin(mins[ti]) ? ' + DESCONTO NO FRETE' : '') + '</em>';
          var prev = mins[ti];
          pfill.style.width = Math.round(((total - prev) / (next - prev)) * 100) + '%';
        } else {
          var totCur = flavorsOf(currentSize).reduce(function (s, f) {
            return s + promoLinha(f, qtys[f.key], mins[ti]).total;
          }, 0);
          var pctMax = f0 ? pctAt(f0, mins[mins.length - 1]) : 0;
          ptxt.innerHTML = '🎉 <em>Desconto máximo desbloqueado</em>' + (pctMax > 0 ? ' — ' + pctMax + '% OFF' : '') + (totCur >= 19990 ? ' + DESCONTO NO FRETE' : '');
          pfill.style.width = '100%';
        }
      }

      // linhas de sabor: preço do tier atual + estado dos steppers
      var soma = 0, somaBase = 0;
      flavorRows().forEach(function (row) {
        var flavor = row.dataset.flavor;
        var input  = row.querySelector('.pops-msc-qty-input');
        var decBtn = row.querySelector('.pops-msc-qty-btn[data-action="dec"]');
        if (input && document.activeElement !== input) input.value = qtys[flavor];
        if (decBtn) decBtn.disabled = qtys[flavor] === 0;
        row.classList.toggle('has-qty', qtys[flavor] > 0);

        var fData = flavorsOf(currentSize).filter(function (x) { return x.key === flavor; })[0];
        if (fData) {
          var q = qtys[flavor];
          var linha = promoLinha(fData, q, mins[ti]);
          var unit = q > 0 ? Math.round(linha.total / q) : unitAt(fData, mins[ti]);
          var base = basePriceOf(fData);
          var chipEl = row.querySelector('[data-msc-solo-chip]');
          if (chipEl) {
            if (!chipEl.dataset.txt) chipEl.dataset.txt = chipEl.textContent;
            if (fData.soloTipo === 'levepague' && fData.soloB > 0 && fData.soloA > fData.soloB) {
              // leve/pague fica sempre visível: convite quando inativo, grátis quando ativo
              chipEl.hidden = false;
              chipEl.textContent = linha.ativa ? '🎁 ' + linha.gratis + ' grátis' : 'Leve ' + fData.soloA + ', pague ' + fData.soloB;
            } else {
              chipEl.hidden = !linha.ativa;
              chipEl.textContent = chipEl.dataset.txt;
            }
          }
          var priceEl = row.querySelector('.pops-msc-flavor-price');
          if (priceEl) {
            while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
            if (unit < base) {
              var sEl = document.createElement('s');
              sEl.textContent = fmtMoney(base);
              sEl.style.opacity = '0.45';
              sEl.style.marginRight = '6px';
              priceEl.appendChild(sEl);
            }
            priceEl.appendChild(document.createTextNode(fmtMoney(unit) + '/un'));
          }
          soma += linha.total;
          somaBase += q * base;
        }
      });

      // resumo
      var sq = wrapper.querySelector('[data-msc-sum-qty]');
      if (sq) sq.textContent = total + ' unidade' + (total === 1 ? '' : 's');
      var sb = wrapper.querySelector('[data-msc-sum-base]');
      if (sb) {
        sb.hidden = !(somaBase > soma);
        sb.textContent = somaBase > soma ? fmtMoney(somaBase) : '';
      }
      var st = wrapper.querySelector('[data-msc-total]');
      if (st) st.textContent = total > 0 ? fmtMoney(soma) : '—';
      var save = wrapper.querySelector('[data-msc-save]');
      if (save) {
        if (somaBase > soma) {
          var pct = Math.round((somaBase - soma) * 100 / somaBase);
          save.hidden = false;
          save.textContent = '🎉 Você está economizando ' + fmtMoney(somaBase - soma) + ' (' + pct + '% OFF)';
        } else {
          save.hidden = true;
        }
      }

      // botão
      if (total > 0) {
        addBtn.classList.remove('not-ready', 'loading');
        addBtn.classList.add('ready');
        addBtn.disabled = false;
        addBtn.textContent = 'Adicionar ' + total + ' un ao carrinho — ' + fmtMoney(soma);
      } else {
        addBtn.classList.remove('ready', 'loading');
        addBtn.classList.add('not-ready');
        addBtn.disabled = true;
        addBtn.textContent = 'Escolha seus sabores';
      }
    }

    buildLadder();
    render();
  };

  // ── Boot ──────────────────────────────────────────────────────
  function bootCombo() {
    document.querySelectorAll('.pops-msc-wrapper:not([data-initialized])').forEach(function (wrapper) {
      wrapper.dataset.initialized = 'true';
      initComboBlock(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', bootCombo);
  document.addEventListener('shopify:section:load', bootCombo);
  document.addEventListener('shopify:section:reorder', bootCombo);

})();
